import { Tracker } from '@pegasus/tracker';

export type Events = 'help_sendMessage_click' | 'TRACK_DATA';
export type Payload = { [key: string]: string };

export const tracker = new Tracker<{ [key in Events]: Payload }>();

export const track = (event: Events, payload: Payload = {}) => tracker.track(event, payload);
